import React from 'react';
import { Col, Row } from 'antd';
import { SectionTitle } from 'components/Section';
import SeeMoreCard from 'components/SeeMoreCard';
import Item from './Item';
import shuffle from 'lib/shuffleArray';

const GRID_COLS = 24;

type Props = {
    title?: string | React.JSX.Element;
    noImages?: boolean;
    noTeaser?: boolean;
    maxItems?: number;
    maxItemsInRow?: number;
    showShowMore?: boolean;
    url?: string;
    galleries: Gallery[];
    videos: Video[];
};

export const MultimediaCardGrid = ({
    galleries,
    videos,
    title,
    noImages = false,
    noTeaser = false,
    maxItems = 4,
    maxItemsInRow = 4,
    showShowMore = false,
    url
}: Props) => {
    const size = { xs: 24, md: Math.floor(GRID_COLS / maxItemsInRow) };

    const slicedItems = shuffle([
        ...galleries.map((gallery): { type: 'gallery'; item: Gallery } => ({
            type: 'gallery',
            item: gallery
        })),
        ...videos.map((video): { type: 'video'; item: Video } => ({ type: 'video', item: video }))
    ]).slice(0, maxItems);

    return (
        <>
            {title && (
                <Row>
                    <Col span={24}>
                        <SectionTitle title={title} url={url} />
                    </Col>
                </Row>
            )}
            <Row key={`section-${title}-grid`} gutter={[16, 30]}>
                {slicedItems.map(({ type, item }) => {
                    if (type === 'gallery') {
                        return (
                            <Item
                                type="gallery"
                                key={`section-${title}-item-${item.seoSlug}`}
                                $item={item}
                                size={size}
                                noImages={noImages}
                                noTeaser={noTeaser}
                            />
                        );
                    }
                    return (
                        <Item
                            type={type}
                            key={`section-${title}-item-${item.seoSlug}`}
                            $item={item}
                            size={size}
                            noImages={noImages}
                            noTeaser={noTeaser}
                        />
                    );
                })}
                {showShowMore && (
                    <Col {...size}>
                        <SeeMoreCard url={url} height={178} width={316} />
                    </Col>
                )}
            </Row>
        </>
    );
};

export default MultimediaCardGrid;
